'use strict'
import awin from '../drivers/awin';
import lomadee from '../drivers/lomadee';
import rakuten from '../drivers/rakuten';
const functions = require('../utils/functions');
const stringSimilarity = require('string-similarity');

class CouponService{

  static listLomadeeStores(callback){
    var storesList = [];
    var couponsFeatured = [];
    lomadee.getCoupons().then((result) => {
      var couponsLomadee = result.data.coupons;
      couponsLomadee.map((coupon, c) => {
        var slug = functions.stringToSlug(coupon.store.name);
        storesList.push({id: coupon.store.id, name: coupon.store.name, image: coupon.store.image, type: 'lomadee', slug: slug, url: coupon.store.link})
      })
      couponsLomadee.map((coupon, c) => {
        couponsFeatured.push(lomadee.convertCoupon(coupon, coupon.store.id));
      });
       //Remove os duplicados
       storesList = storesList.filter((store, index, self) => {
        return self.map(mapObj => mapObj['id']).indexOf(store['id']) === index
      })
      callback(storesList, couponsFeatured);
    })
  }

  static getStore(StoreId, type, callback){
    if(type === 'awin'){
      awin.getStore(StoreId, (err, result) => {
        var store = result.programItem[0];
        callback(awin.convertStore(store));
      });
    }
  }

  static getStores(callback)
  {
    var date = new Date();
    var dateString = date.getFullYear() + date.getMonth() + date.getDate();

    awin.getStores((err, res) => {
      var arrStores = {};
      var storesAwin = {};
      if(res && res.programItems){
        storesAwin = res.programItems.programItem;

        storesAwin.map((store) => {
          var slug = functions.stringToSlug(store.name);
          arrStores[slug] = {
            slug: slug,
            name: store.name,
            idAwin: store['@id'],
            image: store.image,
            type: 'awin'
          };
        });
      }


      lomadee.getStores().then((resL) => {
        var storesLomadee = resL.data.stores;
        //Mescla as lojas com nomes semelhantes
        storesAwin.map((storeA) => {
          storesLomadee.map((storeL) => {
            if(stringSimilarity.compareTwoStrings(storeA.name, storeL.name) > 0.7){
              //Remove o registro único da Awin para inserir o registro mesclado com a Lomadee
              delete arrStores[functions.stringToSlug(storeA.name)]

              var slug = functions.stringToSlug(storeL.name);
              var store = {
                slug: slug,
                name: storeL.name,
                idLomadee: storeL.id,
                idAwin: storeA['@id'],
                image: storeL.image,
                type: 'all'
              }
              arrStores[slug] = store;

            }else{
              var slug = functions.stringToSlug(storeL.name);
              if(arrStores[slug] == undefined){
                var store = {
                  slug: slug,
                  name: storeL.name,
                  idLomadee: storeL.id,
                  image: storeL.image,
                  type: 'lomadee'
                }
                arrStores[slug] = store;
              }
            }
          })
        });
        localStorage.setItem('stores-' + dateString, JSON.stringify(arrStores));
        callback(arrStores);
      })
    })
  }

  static async getStoreCoupons(idLomadee = null, idAwin = null, idRakuten = null, type = 'all', callback)
  {
    var arrCoupons = [];
    if(type == 'all'){

      if(idAwin && idAwin != " "){
        await awin.getStoreCoupons(idAwin, (err, res) => {
          if(err){
            console.log("ERRO AWIN");
          }else{
            var couponsAwin = res.incentiveItems.incentiveItem;
            if(couponsAwin){
              if(couponsAwin.length){
                couponsAwin.map((coupon, c) => {
                  //Remove os cupons que não possuirem link
                  if(coupon.admedia.admediumItem.trackingLinks != ""){
                    arrCoupons.push(awin.convertCoupon(coupon, coupon.program['@id']));
                  }
                });
              }else{
                arrCoupons.push(awin.convertCoupon(couponsAwin, couponsAwin.program['@id']));
              }
            }
          }
        });
      }

      if(idLomadee && idLomadee != " "){
        await lomadee.getStoreCoupons(idLomadee).then((resL) => {
          var couponsLomadee = resL.data.coupons;
          if(couponsLomadee){
            couponsLomadee.map((coupon, c) => {
              arrCoupons.push(lomadee.convertCoupon(coupon, coupon.store.id));
            });
          }
        }, (err) => {
          console.log("ERRO LOMADEE")
        });
      }

      if(idRakuten && idRakuten != " "){

      }

      //Chamada da rakuten

      callback(arrCoupons);

    }else if(type == 'awin'){
      awin.getStoreCoupons(idAwin, (err, res) => {
        var couponsAwin = res.incentiveItems.incentiveItem;
        if(couponsAwin){
          if(couponsAwin.length){
            couponsAwin.map((coupon, c) => {
              //Remove os cupons que não possuirem link
              if(coupon.admedia.admediumItem.trackingLinks != ""){
                arrCoupons.push(awin.convertCoupon(coupon, coupon.program['@id']));
              }
            });
          }else{
            arrCoupons.push(awin.convertCoupon(couponsAwin, couponsAwin.program['@id']));
          }
        }
        callback(arrCoupons);
      });
    }else if(type == 'lomadee'){
      lomadee.getStoreCoupons(idLomadee).then((resL) => {
        var couponsLomadee = resL.data.coupons;
        if(couponsLomadee){
          couponsLomadee.map((coupon, c) => {
            arrCoupons.push(lomadee.convertCoupon(coupon, coupon.store.id));
          });
        }
        callback(arrCoupons);
      });
    }else if(type == 'rakuten'){

    }
  }

  static getStoreProducts(idLomadee = null, idAwin = null, idRakuten = null, type = 'all', callback)
  {
    var arrCoupons = [];
    if(type == 'all'){
      awin.getStoreCoupons(idAwin, (err, res) => {
        var couponsAwin = res.incentiveItems.incentiveItem;
        if(couponsAwin){
          if(couponsAwin.length){
            couponsAwin.map((coupon, c) => {
              //Remove os cupons que não possuirem link
              if(coupon.admedia.admediumItem.trackingLinks != ""){
                arrCoupons.push(awin.convertCoupon(coupon, coupon.program['@id']));
              }
            });
          }else{
            arrCoupons.push(awin.convertCoupon(couponsAwin, couponsAwin.program['@id']));
          }
        }

        lomadee.getStoreCoupons(idLomadee).then((resL) => {
          var couponsLomadee = resL.data.coupons;
          if(couponsLomadee){
            couponsLomadee.map((coupon, c) => {
              arrCoupons.push(lomadee.convertCoupon(coupon, coupon.store.id));
            });
          }

          callback(arrCoupons);
        });
      });
    }else if(type == 'awin'){
      awin.getStoreCoupons(idAwin, (err, res) => {
        var couponsAwin = res.incentiveItems.incentiveItem;
        if(couponsAwin){
          if(couponsAwin.length){
            couponsAwin.map((coupon, c) => {
              //Remove os cupons que não possuirem link
              if(coupon.admedia.admediumItem.trackingLinks != ""){
                arrCoupons.push(awin.convertCoupon(coupon, coupon.program['@id']));
              }
            });
          }else{
            arrCoupons.push(awin.convertCoupon(couponsAwin, couponsAwin.program['@id']));
          }
        }
        callback(arrCoupons);
      });
    }else if(type == 'lomadee'){
      lomadee.getStoreCoupons(idLomadee).then((resL) => {
        var couponsLomadee = resL.data.coupons;
        if(couponsLomadee){
          couponsLomadee.map((coupon, c) => {
            arrCoupons.push(lomadee.convertCoupon(coupon, coupon.store.id));
          });
        }
        callback(arrCoupons);
      });
    }
  }
}

export default CouponService


// WEBPACK FOOTER //
// ./src/services/coupon.js